import customaxios from ".";
import { getAuthToken, getRefreshToken } from "../common/routines/user-operations";

export const login = (data: unknown) => {
  return customaxios({
    method: "POST",
    url: `/login`,
    data,
  });
};

export const userRefreshToken = (userType: string = "user") => {
  const refreshToken = getRefreshToken(userType);
  if (!refreshToken) {
    throw new Error("No refresh token found");
  }
  return customaxios({
    method: "POST",
    url: "/auth/refresh-token",
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
    data: { refreshToken },
    withCredentials: true, // if refresh token is stored in cookies
  });
};

export const adminRefreshToken = (userType: string = "superAdmin") => {
  const refreshToken = getRefreshToken(userType);
  if (!refreshToken) {
    throw new Error("No refresh token found");
  }
  return customaxios({
    method: "POST",
    url: "/auth/admin/refresh-token",
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
    data: { refreshToken },
    withCredentials: true, // if refresh token is stored in cookies
  });
};

export const requestOTP = (data: unknown) => {
  return customaxios({
    method: "POST",
    url: "/auth/request-otp",
    data,
  });
};

export const verifyOTP = (data: unknown) => {
  return customaxios({
    method: "POST",
    url: "/auth/verify-otp",
    data,
  });
};

export const userLogout = () => {
  const token = getAuthToken("user");
  return customaxios({
    method: "POST",
    url: "/auth/logout",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true, // if refresh token is stored in cookies
  });
};

export const adminLogin = (data: unknown) => {
  return customaxios({
    method: "POST",
    url: `/auth/admin/login`,
    data,
  });
};

export const providerLogin = (data: unknown) => {
  return customaxios({
    method: "POST",
    url: `/auth/provider/login`,
    data,
  });
};

//  PRENEED login (added)
export const preNeedLogin = (email: string, password: string) => {
  const formData = new URLSearchParams();
  formData.append("email", email);
  formData.append("password", password);

  return customaxios({
    method: "POST",
    url: `/auth/planner/login`, //  fixed
    data: formData,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};


export const providerRefreshToken = (userType: string = "provider") => {
  const refreshToken = getRefreshToken(userType);
  if (!refreshToken) {
    throw new Error("No refresh token found");
  }

  return customaxios({
    method: "POST",
    url: "/auth/provider/refresh-token",
    headers: {
      Authorization: `Bearer ${refreshToken}`,
      source: "AFH",
    },
    data: { refreshToken },
    withCredentials: true, // if refresh token is stored in cookies
  });
};

//  PRENEED refresh token (added)
export const preNeedRefreshToken = (userType: string = "preNeed") => {
  const refreshToken = getRefreshToken(userType);
  if (!refreshToken) {
    throw new Error("No refresh token found");
  }

  return customaxios({
    method: "POST",
    url: "/auth/planner/refresh-token", //  likely correct
    headers: {
      Authorization: `Bearer ${refreshToken}`,
      source: "AFH",
    },
    data: { refreshToken },
    withCredentials: true,
  });
};


export const providerForgotPwd = (email: string) => {
  const formData = new URLSearchParams();
  formData.append("email", email);

  return customaxios({
    method: "POST",
    url: "/auth/provider/forgot-password",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData,
  });
};
//  PRENEED forgot password (added)
export const preNeedForgotPwd = (email: string) => {
  const formData = new URLSearchParams();
  formData.append("email", email);

  return customaxios({
    method: "POST",
    url: "/auth/planner/forgot-password",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData,
  });
};
export const providerResetPassword = (payload: {
  token: string;
  newPassword: string;
  confirmPassword: string;
}) => {
  const formData = new URLSearchParams();
  formData.append("token", payload.token);
  formData.append("newPassword", payload.newPassword);
  formData.append("confirmPassword", payload.confirmPassword);

  return customaxios({
    method: "POST",
    url: "/auth/provider/reset-password",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData,
  });
};
export const preneedResetPassword = (payload: {
  token: string;
  newPassword: string;
  confirmPassword: string;
}) => {
  const formData = new URLSearchParams();
  formData.append("token", payload.token);
  formData.append("newPassword", payload.newPassword);
  formData.append("confirmPassword", payload.confirmPassword);

  return customaxios({
    method: "POST",
    url: "/auth/planner/reset-password",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData,
  });
};

//calling api to check whether the user is already existing or not

export const checkExistingUser = (data: unknown) => {
  return customaxios({
    method: "POST",
    url: "/auth/check-existing-user",
    data,
  });
};